import { render } from "./SelectDateV2.vue?vue&type=template&id=08c1a613&ts=true"
import script from "./SelectDateV2.vue?vue&type=script&lang=ts"
export * from "./SelectDateV2.vue?vue&type=script&lang=ts"

import "./SelectDateV2.vue?vue&type=style&index=0&id=08c1a613&lang=css"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__